import { SelectItem } from '../components/forms/Select/Select.view';
import { SocialOAuthProvider } from '../models/graphql';

export enum TreeMenuModalTypeEnums {
  ADD_FOLDER = 'ADD_FOLDER',
  RENAME_FOLDER = 'RENAME_FOLDER',
  DELETE_FOLDER = 'DELETE_FOLDER',
  RENAME_SOURCE = 'RENAME_SOURCE',
  DELETE_SOURCE = 'DELETE_SOURCE'
}

export enum ImportSourceType {
  RSS = 'RSS',
  FACEBOOK = 'FACEBOOK',
  TWITTER = 'TWITTER',
  LINKEDIN = 'LINKEDIN',
  PINTEREST = 'PINTEREST',
  INSTAGRAM = 'INSTAGRAM'
}

export enum PostSourceType {
  TwitterSocialProfile = 'TwitterSocialProfile',
  FacebookSocialProfile = 'FacebookSocialProfile',
  LinkedInSocialProfile = 'LinkedInSocialProfile',
  InstagramSocialProfile = 'InstagramSocialProfile',
  PinterestSocialProfile = 'PinterestSocialProfile'
}

export const platformItems: SelectItem[] = [
  {
    label: 'Facebook',
    value: SocialOAuthProvider.FACEBOOK
  },
  {
    label: 'Instagram',
    value: SocialOAuthProvider.INSTAGRAM
  },
  {
    label: 'LinkedIn',
    value: SocialOAuthProvider.LINKEDIN
  },
  {
    label: 'Pinterest',
    value: SocialOAuthProvider.PINTEREST
  },
  {
    label: 'RSS',
    value: 'RSS'
  }
];

export const MaxSelectedPostsToImport = 500;
export const MaxImagesPerPostsForImport = 50;
export const MaxCsvFileSize = 15 * 1048576; // 15MB
